var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"aria-haspopup":"true","aria-expanded":_vm.isActive}},[_c('span',[_vm._v(_vm._s(_vm.name))]),_c('i',{staticClass:"far fa-chevron-down"})])
}
var staticRenderFns = []

export { render, staticRenderFns }